import { SubscriptionPlan } from '@/models/api/subscriptions'

export type SubscriptionPlanType = 'Basic' | 'Free'

//hardcoded for now
export const subscriptionPlans: SubscriptionPlan[] = [
	{ id: 1, name: 'Free', planName: 'DocFree', price: 0, description: 'Non integrated scheduling', planId: 1 },
	// { id: 1, name: 'Premium', planName: 'DocPremium', price: 100, description: 'Integrated scheduling with AtenaHealth' }
	// TODO: delete this when stripe becomes active
	{
		id: 2,
		name: 'Basic',
		planName: 'DocPremium',
		price: 100,
		description: 'Integrated scheduling with AtenaHealth',
		planId: 2
	}
]
